import { CommonAPIService } from 'src/servicehandlers/CommonHandler';

export class EventRoomsAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  get(router) {
    const url = `/api/eventRooms`;
    return this.CommonAPIService.getCall(url, '', router);
  }

  getEventById(roomId, router){
    const url = `/api/eventRooms/${roomId}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  create(params, router) {
    const url = '/api/eventRooms';
    return this.CommonAPIService.postCall(url, params, router);
  }

  delete(roomId, params, router) {
    const url = `/api/eventRooms/${roomId}`;
    return this.CommonAPIService.deleteCall(url, params, router);
  }

  update(roomId, params, router) {
    const url = `/api/eventRooms/${roomId}`;
    return this.CommonAPIService.putCall(url, params, router);
  }
}
export default EventRoomsAPIService;
